/**
 * Pantalla de espera que se muestra en la pestaña nueva mientras se prepara
 * un adjunto. La pestaña parte vacía (sin los estilos del admin), así que los
 * estilos van en línea; los colores son los $pw-* de src/styles/variables.scss.
 */
import logoUrl from '../assets/new_Pawer_Logo.png';

const STYLES = `
  * { box-sizing: border-box; }
  html, body { height: 100%; margin: 0; }
  body {
    display: flex; align-items: center; justify-content: center;
    padding: 24px;
    background: #F7F8FA;
    color: #111827;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  .card {
    width: 100%; max-width: 380px;
    padding: 36px 32px 32px;
    background: #FFFFFF;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(16, 75, 148, 0.08);
    text-align: center;
  }
  .logo { display: block; height: 32px; margin: 0 auto 28px; }
  .spinner {
    width: 44px; height: 44px; margin: 0 auto 20px;
    border: 4px solid #E8F0FB;
    border-top-color: #104B94;
    border-radius: 50%;
    animation: spin 0.9s linear infinite;
  }
  .title { margin: 0 0 6px; font-size: 17px; font-weight: 600; }
  .detail { margin: 0; font-size: 14px; line-height: 1.5; color: #6B7280; }
  @keyframes spin { to { transform: rotate(360deg); } }
  @media (prefers-reduced-motion: reduce) {
    .spinner { animation-duration: 2.4s; }
  }
`;

const MARKUP = `
  <main class="card" role="status" aria-live="polite">
    <img class="logo" src="${logoUrl}" alt="Pawer">
    <div class="spinner" aria-hidden="true"></div>
    <p class="title" id="loading-title"></p>
    <p class="detail" id="loading-detail"></p>
  </main>
`;

/**
 * Actualiza el mensaje de la pantalla de espera.
 *
 * @param {Window} tab - Pestaña donde se muestra.
 * @param {{ title: string, detail: string }} message
 */
export function setLoadingMessage(tab, { title, detail }) {
  tab.document.title = title;
  tab.document.getElementById('loading-title').textContent = title;
  tab.document.getElementById('loading-detail').textContent = detail;
}

/**
 * Pinta la pantalla de espera en una pestaña recién abierta.
 *
 * @param {Window} tab - Pestaña vacía abierta con window.open('').
 * @param {{ title: string, detail: string }} message - Mensaje inicial.
 */
export function renderLoadingPage(tab, message) {
  const doc = tab.document;
  const style = doc.createElement('style');
  style.textContent = STYLES;
  doc.head.appendChild(style);
  // Solo contenido estático: los textos variables entran con textContent.
  doc.body.innerHTML = MARKUP;
  setLoadingMessage(tab, message);
}
